import { render, staticRenderFns } from "./IndexTenantOne.vue?vue&type=template&id=192e1892&"
import script from "./IndexTenantOne.vue?vue&type=script&lang=js&"
export * from "./IndexTenantOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports